import { useEffect, useState } from 'react';
import { Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import ErrorList from 'Lib/components/errors/ErrorList';
import isFunction from 'Lib/utilities/isFunction';

const PromptModal = props => {
    const { isOpen, children, header, renderConfirm, scrollable = false, showErrors, size = 'md', styleOverride, stickyFooter, zIndex = 2000, buttons, onClose, body } = props;
    const [isProcessing, setIsProcessing] = useState(false);
    const [confirmText, setConfirmText] = useState('');
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        setConfirmText('');
    }, [isOpen]);

    const renderButtons = () => {
        if (isFunction(buttons)) {
            return buttons({
                isProcessing,
                isDisabled: renderConfirm ? (confirmText.toLowerCase() === 'delete' ? false : true) : false,
                setProcessing: setIsProcessing,
                setErrors,
                close: onClose
            });
        } else if (Array.isArray(buttons)) {
            return buttons.map((item, index) => <span key={index}>{item}</span>);
        }
    };

    const renderBody = () => (isFunction(body) ? body() : body);

    const renderConfirmInput = () => (
        <>
            <br />
            <Input style={{ width: '55%' }} type="text" name="confirm" id="confirm" placeholder="Type 'DELETE' to confirm" onChange={e => setConfirmText(e.target.value)} />
        </>
    );

    const stickyFooterStyle = { position: 'sticky', bottom: '0', background: 'white' };

    return (
        <Modal toggle={onClose} isOpen={isOpen} keyboard={true} size={size} style={styleOverride} scrollable={scrollable} zIndex={zIndex}>
            <ModalHeader toggle={onClose}>{header}</ModalHeader>
            <ModalBody style={{ overflowX: 'visible' }}>
                <div>{renderBody()}</div>
                {renderConfirm ? renderConfirmInput() : null}
                <div>{children}</div>
                {showErrors && <ErrorList errors={errors} />}
            </ModalBody>
            <ModalFooter style={stickyFooter ? stickyFooterStyle : null}>{renderButtons()}</ModalFooter>
        </Modal>
    );
};

export default PromptModal;
